import type {ExtractPropsWithoutRef} from '@/types';

import {useTranslation} from 'react-i18next';

import {FilterCategoryItems} from '@/components/FilterCategoryItems';
import {config} from '@/config';
import {FilterTile} from '@/modules/common/components/Filter/FilterTile';

type Props = ExtractPropsWithoutRef<'div'> & {
  options: ExtractPropsWithoutRef<typeof FilterCategoryItems>['items'];
  onChange: ExtractPropsWithoutRef<typeof FilterCategoryItems>['onChange'];
  caption: string | React.ReactNode;
  canShowOptionBestPrice?: boolean;
};

export const CategoryFilter: React.FunctionComponent<Props> = ({
  options,
  canShowOptionBestPrice = false,
  onChange,
  ...restProps
}) => {
  const {t} = useTranslation('filters');

  return (
    <FilterTile
      {...restProps}
      helpArticle={
        config.filters.category.showTooltip ? t('tooltips.stars') : undefined
      }
    >
      <FilterCategoryItems
        items={options}
        canShowOptionBestPrice={canShowOptionBestPrice}
        onChange={onChange}
      />
    </FilterTile>
  );
};
